import React, { useRef } from 'react'; import { DoubleSide } from 'three';
import { useGLTF } from '@react-three/drei'

export function Anhh(props) {
    const group = useRef();
    const { nodes } = useGLTF('3ds/an/Anhh.gltf');
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                name="Anhh"
                geometry={nodes.Anhh.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/Anhh.gltf')